import axios from "axios";

const baseApiUrl = process.env.REACT_APP_BASE_API;

const axiosCall = async (method, url, data = "", headers = "") => {
  try {
    let options = {
      method,
      url,
    };
    if (headers) options.headers = headers;
    if (data) options.data = data;

    const response = await axios(options);
    return response.data;
  } catch (err) {
    if (err && err.response && err.response) return err.response.data;
    else
      return { code: 500, message: "Oops! Something went wrong.", data: null };
  }
};

// export const userLoginApi = (data) => {
//   return axiosCall("POST", `${baseApiUrl}/v1/user/login`, data);
// };

export const userLoginApi = async (data) => {
  try {
    const resp = await axios.post(`${baseApiUrl}/v1/user/login`, data);
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const Signup = async (data) => {
  try {
    const resp = await axios.post(`${baseApiUrl}/v1/user/sign-up`, data);
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const SendOtp = async (data) => {
  try {
    const resp = await axios.post(`${baseApiUrl}/v1/user/validate`, data);
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const VerifyOtp = async (data) => {
  try {
    const resp = await axios.post(`${baseApiUrl}/v1/user/validate-otp`, data);
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const ResendOtp = async (data) => {
  try {
    const resp = await axios.post(`${baseApiUrl}/v1/user/validate`, data);
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const UpdatePassword = async (data) => {
  try {
    const resp = await axios.patch(`${baseApiUrl}/v1/user/update-user`, data);
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const purposefetchData = () => {
  return axiosCall("GET", `${baseApiUrl}/v1/accounts/purpose`);
};

export const fetchDetails = (data) => {
  return axiosCall("GET", `${baseApiUrl}/v1/accounts?accountType=${data}`);
};

export const fetchRemitterBankDetail = (data) => {
  return axiosCall("GET", `${baseApiUrl}/v1/bank?userAccountId=${data}`);
};

export const userSearch = async (searchText, partnerCode, appName) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/accounts/user-search?searchText=${searchText}&partnerCode=${partnerCode}&appName=${appName}`
    );
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const fetchUser = async (userId, appName) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/accounts/fetch-user?userId=${userId}&appName=${appName}`
    );
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const saveBankDetail = async (data, userID) => {
  try {
    const resp = await axios.put(
      `${baseApiUrl}/v1/bank?userAccountId=${userID}`,
      data
    );
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const onBoardPersonalDetail = async (data) => {
  try {
    const resp = await axios.post(`${baseApiUrl}/v1/accounts`, data);
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const onBoardingPersonalDetailUpdate = async (payload) => {
  try {
    const resp = await axios.patch(
      `${baseApiUrl}/v1/accounts/update-account`,
      payload
    );
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const KycUploadApi = async (ID) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/onboarding/digilocker/url?accountId=${ID}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const documentUploadApi = async (
  userAccountID,
  fileType,
  docType,
  side,
  body
) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/accounts/upload-doc?userAccountId=${userAccountID}&fileName=studentId&fileType=${fileType}&docType=${docType}&side=${side}`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const statusApi = async (ID) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/accounts?userAccountId=${ID}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const quoteGeneration = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v2/transaction/generate-quote`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const generateA2SignApi = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/transaction/process-a2-esign`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const generatePaymentLink = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/transaction/generate-quote`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const documentPurposeUpload = async (
  transactionId,
  studentUserId,
  fileName,
  fileType,
  docType,
  formData,
  side
) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/transaction/upload-doc?fileType=${fileType}&transactionId=${transactionId}&fileName=${fileName}&userAccountId=${studentUserId}&docType=${docType}&side=${side}`,
      formData
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getTransactionList = async (page, from, to, status) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/transaction/get-transaction-list?pageNumber=${page}&statusString=${status}&from=${from}&to=${to}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const paymentLink = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/transaction/generate-pay-link`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getTransactionDetailUsingId = async (id) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/transaction/get-transaction-list?transactionId=${id}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getDocToBeUpload = async (transactionId) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/transaction/purpose-document?transactionId=${transactionId}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const generateDirectQuote = (body) => {
  return axiosCall(
    "POST",
    `${baseApiUrl}/v1/transaction/direct-generate-quote`,
    body
  );
};

export const reUploadOfDocuments = (transactionId,redirectionLink) => {
  return axiosCall(
    "POST",
    `${baseApiUrl}/v1/transaction/reupload-doc?transactionId=${transactionId}&redirectUrl=${redirectionLink}`
  );
};

export const createPlan = (body) => {
  return axiosCall("POST", `${baseApiUrl}/v1/user/plan`, body);
};

export const userDetails = () => {
  return axiosCall("GET", `${baseApiUrl}/v1/user/details`);
};

export const countryBankApi = async (partnerCode) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/country-list?partnerCd=${partnerCode}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getBankList = () => {
  return axiosCall("GET", `${baseApiUrl}/v1/bank/list`);
};

export const onBoardOfflinePersonalDetail = async (data) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/offline-transaction/account`,
      data
    );
    return resp;
  } catch (error) {
    return error.response;
  }
};

export const offlineTransactionCreation = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/offline-transaction/create-transaction`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const offlineSubmitTransaction = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/offline-transaction/submit-transaction`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getOfflineExchangeRate = async (
  mode,
  currency,
  partnerShortCode
) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/transaction/exchange-rate?currency=${currency}&mode=${mode}&partnerShortCode=${partnerShortCode}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getUploadedDocuments = async (studentAccountId) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/transaction/approved/docs?studentAccountId=${studentAccountId}&remitterAccountId=NaN`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const submitUploadedDocuments = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/transaction/upload/docs`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getIbrDetails = (currency) => {
  return axiosCall(
    "GET",
    `${baseApiUrl}/v1/transaction/ibr?currency=${currency}`
  );
};

export const validateTransaction = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/transaction/validate-transaction`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const getLrsQuote = async (referenceId) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/accounts/get-lrs-quote?referenceId=${referenceId}`
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};

export const addLrsQuote = async (body) => {
  try {
    const resp = await axios.post(
      `${baseApiUrl}/v1/accounts/add-lrs-quote`,
      body
    );
    return resp.data;
  } catch (error) {
    return error.response;
  }
};


export const getRefCode = async (refCode) => {
  try {
    const resp = await axios.get(
      `${baseApiUrl}/v1/client/exists?refCode=${refCode}`
    );
    return resp;
  } catch (error) {
    return error.response;
  }
};